import { z } from 'zod';

export const DataClass = z.enum(['raw_events', 'interaction_facts', 'message_payloads', 'audit', 'sdk_debug_logs']);
export const ArchiveMode = z.enum(['delete', 'cold_storage']);

export const RetentionPolicyView = z.object({
  dataClass: DataClass,
  retainDays: z.number().int(),
  archiveMode: ArchiveMode,
  /** The next run only counts what it would remove (new or changed policy). */
  dryRunPending: z.boolean(),
  updatedAt: z.string(),
  lastRun: z
    .object({ status: z.enum(['dry_run', 'completed', 'failed']), startedAt: z.string(), rowsAffected: z.number(), cutoff: z.string() })
    .nullable(),
});
export type RetentionPolicyView = z.infer<typeof RetentionPolicyView>;

export const UpdateRetentionBody = z.object({
  policies: z
    .array(z.object({ dataClass: DataClass, retainDays: z.number().int(), archiveMode: ArchiveMode.optional() }))
    .min(1)
    .max(5),
});
export type UpdateRetentionBody = z.infer<typeof UpdateRetentionBody>;
